<div class="col-lg-12 col-md-12 col-sm-12 card" [ngClass]="{'dark-mode': darkMode}">
  <div class="card-header border-header">
    <div class="row d-flex justify-content-between align-items-center p-2">
      <h3 class="" translate>licensePlates.licensePlates</h3>
      <!-- search -->
      <div *ngIf="role === 'root'" class="d-flex search-container">
        <div class="search-text d-flex">
          <input type="text" class="search" (input)="applyFilterOnAddedPlates()" [(ngModel)]="searchParamAll"
            [attr.placeholder]="'licensePlates.searchLicensePlates' | translate">
          <div class="d-flex flex-row align-items-center">
            <span class="exit" (click)="clearSearch()"></span>
            <span class="line"></span>
          </div>
        </div>
        <span class="search-icon"><i class="fa fa-search"></i></span>
      </div>
      <!-- ./search -->
      <div *ngIf="currentUser.role.name === 'root'">
        <button type="button" class="custom-button add-button mr-2"
          (click)="showDialogAddLicensePlate(addLicensePlateModal)">Create
          License Plate <i class="fa fa-plus" style="margin-left: 7px;"></i></button>
      </div>
    </div>

  </div>
  <div *ngIf="role !== 'root'" class="form-group">
    <!-- search -->
    <div #searchContainer [ngClass]="{'active' : showMyContainer}" class="div select-bg search-container"
      style="display: block;">
      <input type="text" readonly class="search" style="height: 44px; display: block; width: 100%; padding-left: 12px;"
        (click)="openDropdown()" name="selectedLicensePlate" [(ngModel)]="selectLicensePlate">

      <div class="prikaz" *ngIf="showMyContainer">
        <div class="backdrop" (click)="openDropdown()"></div>
        <div style="z-index: 100; overflow-y: auto;">
          <div class="divider"></div>
          <input type="text" class="search-marke" (input)="applyFilter()" [attr.placeholder]="'user.search' | translate"
            name="searchParam" name="searchParam" [(ngModel)]="searchParam">
          <ul style="margin-bottom: 12px;">
            <li *ngFor="let licensePlate of licensePlatesSearch" (click)="assignLicensePlate(licensePlate.id)">
              {{ licensePlate?.name }}
              <ng-container>
                <div class="position-relative">
                  <div class="bg-all-files" style="cursor: pointer;"
                    [style.background-image]="licensePlate?.file ? 'url(' + licensePlate.file?.thumbnailPath + ')' : 'url(assets/img/no-image.png)'">
                  </div>
                </div>
              </ng-container>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>

  <hr>
  <div class="card-body">
    <div class="row">
      <div *ngIf="licensePlatesSearchAll && !licensePlatesSearchAll.length" style="min-height: 60px;">
        <p class="no-data-message" translate>licensePlates.noLicensePlates</p>
      </div>
      <div class="col-md-3 col-sm-6"
        *ngFor="let licensePlate of licensePlatesSearchAll | slice: (page-1) * perPage : (page-1) * perPage + perPage; let index = index">
        <div class="root-application-bg-container ">
          <div class="root-application-image-delete" style="cursor: pointer;"
            (click)="openLicensePlateModal(dialogDelete, licensePlate)"></div>
          <div *ngIf="currentUser.role.name === 'root'" class="root-application-image-delete settings-icon"
            style="cursor: pointer; left: 0;" (click)="onEditLicensePlate(addLicensePlateModal, (page-1) * perPage + index)"></div>
          <div class="root-application-bg" [style.background-image]="(licensePlate.file != null) ? 'url(' + licensePlate.file?.thumbnailPath + ')' : 'url(assets/img/no-image.png)'">
          </div>
          <div class="root-application-filename widget-user-username"> {{licensePlate.name}}</div>
        </div>
      </div>
    </div>
    <ngb-pagination *ngIf="licensePlatesSearchAll && licensePlatesSearchAll.length > 16"
      [collectionSize]="licensePlatesSearchAll.length" [(pageSize)]="perPage" [(page)]="page" [maxSize]="5"
      [rotate]="true" (pageChange)="jumpToPage($event)"></ngb-pagination>
  </div>
</div>

<!-- add license plate -->
<ng-template #addLicensePlateModal>
  <div class="backdrop-content">
    <form [formGroup]="licensePlateForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="name">Name:</label>
        <input type="text" id="name" formControlName="name" class="form-control" placeholder="Enter name..."
          [class.is-invalid]="licensePlateForm.get('name').invalid && licensePlateForm.get('name').touched">
        <small class="text-danger"
          [class.d-none]="licensePlateForm.get('name').valid || licensePlateForm.get('name').untouched">
          Name is required
        </small>
      </div>

      <!-- <div *ngIf="!editingMode" class="form-group">
        <label for="file">Choose File:</label>
        <input type="file" id="file" (change)="onFileChange($event)" 
          [class.is-invalid]="licensePlateForm.get('file').invalid && licensePlateForm.get('file').touched">
        <small class="text-danger"
          [class.d-none]="licensePlateForm.get('file').valid || licensePlateForm.get('file').untouched">
          File is required
        </small>
      </div> -->

      <div class="form-group">
        <label for="file">File:</label>
        <input id="file" type="file" style="display: none;" (change)="onFileChange($event)">

        <div *ngIf="editingMode; else uploadFile" class="form-group">
          <img [src]="currentImageUrl" style="cursor: pointer;" alt="Current Image" class="img-thumbnail" (click)="fileSelectorOpen()" />
        </div>
        
        <ng-template #uploadFile>
          <div *ngIf="!currentImageUrl" class="d-flex justify-content-between" style="cursor: pointer;" (click)="fileSelectorOpen()">
            <span>Upload File</span>
            <span><i class="fa fa-upload"></i></span>
          </div>

          <img *ngIf="currentImageUrl" [src]="currentImageUrl" style="cursor: pointer;" alt="Current Image" class="img-thumbnail" (click)="fileSelectorOpen()" />

          <small class="text-danger"
            [class.d-none]="licensePlateForm.get('file').valid || licensePlateForm.get('file').untouched">
            File is required
          </small>
        </ng-template>

      </div>

      <div class="form-group" style="display: flex; flex-direction: column; gap: 1rem">
        <button class="btn btn-primary w-100" type="submit" [disabled]="!licensePlateForm.valid">{{ editingMode ? 'Update License Plate' : 'Add License Plate'
          }}</button>
        <button class="btn btn-primary w-100" type="button" (click)="cancelEditing()" *ngIf="editingMode">Cancel</button>
      </div>
    </form>

  </div>
</ng-template>

<!-- Modal delete license Plate -->
<ng-template #dialogDelete let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h3 class="modal-title" style="font-size: 16px">Are you sure you want to delete <span
        style="font-weight: bold;">{{selectedLicensePlate.name}}</span> ?</h3>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <button type="button" class="btn btn-outline-dark btn-yes" (click)="deleteLicensePlate(selectedLicensePlate)"
      translate>global.yes</button>
    <button type="button" class="btn btn-outline-dark btn-no" (click)="c('No click')" translate>global.no</button>
  </div>
</ng-template>

